export var DEFAULT_NAMESPACE = '/';
export var ACTION_TYPE_DELIMITER = '||';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/constants.js
// module id = ./node_modules/redux-actions/es/constants.js
// module chunks = 6 9 11